import * as React from "react";
import { styled, CircularProgress } from "@mui/material";
import backgroundImage from "../../assets/background-image.jpg";
import { SingleViewPerLayoutBreakPoint } from "../../util/aKaunGeneralUtil";
import { ChromeTypography } from "fe-web-components/styles/typography";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { NavBarZIndex } from "fe-common/ui/stacking";

//region [[ Styles ]]

export const NavBarHeight = 80;

const TopNavigationView = styled("div")(({ theme }) => ({
  padding: theme.spacing(2),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
  height: `${NavBarHeight}px`,
  justifyContent: "space-between",
  background: `${KahunColorMap.Primary}`,
  backgroundImage: `url('${backgroundImage}')`,
  backgroundPosition: "right",
  backgroundRepeat: "no-repeat",
  position: "sticky",
  top: 0,
  zIndex: NavBarZIndex,
  [theme.breakpoints.down("xs")]: {
    padding: theme.spacing(1),
    backgroundPosition: "right",
    backgroundBlendMode: "soft-light",
  },
  [theme.breakpoints.down("md")]: {},
  [theme.breakpoints.down("lg")]: {},
}));

const RightSection = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
});

const LeftSection = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "left",
});

const MainTitle = styled(({ ...props }: {children?: any}) => (
  <ChromeTypography variant="h4" {...props} />
))(({ theme }) => ({
  color: "White",
  [theme.breakpoints.down("xs")]: {
    fontSize: "1.2em",
  },
}));

const SubTitle = styled(({ ...props }: {children?: any}) => (
  <ChromeTypography variant="subtitle1" {...props} />
))({
  color: "white",
});

const LoadingIcon = styled(CircularProgress)(({ theme }) => ({
  [theme.breakpoints.up(SingleViewPerLayoutBreakPoint)]: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(2),
  },
}));
const MiddleSection = styled("div")({});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface TopNavigationProps {
  className?: string;
  leftSectionItems?: React.ReactElement;
  middleSectionItems?: React.ReactElement;
  rightSectionItems?: React.ReactElement;
  title?: string;
  subtitle?: string;
  loading?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const TopNavigation = ({ ...props }: TopNavigationProps) => {
  return (
    <TopNavigationView className={props.className}>
      <LeftSection className="left">
        {props.leftSectionItems}
        <MainTitle>
          {props.title}
          {props.subtitle && <SubTitle>{props.subtitle}</SubTitle>}
        </MainTitle>
        {props.loading && <LoadingIcon />}
      </LeftSection>
      <MiddleSection className="middle">
        {props.middleSectionItems}
      </MiddleSection>
      <RightSection className="right">{props.rightSectionItems}</RightSection>
    </TopNavigationView>
  );
};
